<template>
  <v-container fluid>
    <v-row>
      <v-col cols="11" offset-lg="1">
        <div class="headline mb-3">用語集設定</div>
        <permission-guard situation="widget_management">
          <!-- 後でかえる -->
          <v-btn
            color="primary"
            dark
            tile
            class="ma-2"
            to="/admin/glossary_phrases/new"
          >
            新規作成
          </v-btn>
          <template v-if="site.displayGlossary">
            <v-btn
              :href="publicUrl()"
              target="_blank"
              class="ml-auto"
              tile
              small
              outlined
            >
              公開ページ
            </v-btn>
            <v-btn
              color="error"
              tile
              small
              @click="toggleDisplayGlossary(site.displayGlossary)"
            >
              用語集を非公開にする
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              :href="previewUrl()"
              target="_blank"
              class="ml-auto"
              tile
              small
              outlined
            >
              プレビューを確認する
            </v-btn>
            <v-btn
              color="success"
              tile
              small
              @click="toggleDisplayGlossary(site.displayGlossary)"
            >
              用語集を公開する
            </v-btn>
          </template>

          <v-layout row>
            <v-text-field
              v-model="query.name_cont"
              label="用語名"
              style="width: 100px"
              class="ml-2 caption"
              clearable
            />
            <v-text-field
              v-model="query.reading_ja_cont"
              label="読み"
              style="width: 100px"
              class="ml-2 caption"
              clearable
            />

            <v-btn
              color="primary"
              dark
              tile
              outlined
              class="mx-2"
              @click="search"
            >
              絞り込む
            </v-btn>
          </v-layout>
          <v-simple-table fixed-header>
            <template>
              <thead>
                <tr>
                  <th class="text-center" style="width: 30px">ID</th>
                  <th style="min-width: 200px">
                    用語名
                  </th>
                  <th style="min-width: 200px">読み</th>
                  <th class="text-center" />
                  <th class="text-center" />
                  <th class="text-center" />
                </tr>
              </thead>
              <tbody>
                <tr v-for="(glossaryPhrase, index) in glossaryPhrases" :key="glossaryPhrase.id">
                  <td>{{ glossaryPhrase.id }}</td>
                  <td>{{ glossaryPhrase.name }}</td>
                  <td>{{ glossaryPhrase.readingJa }}</td>
                  <td class="text-center">
                    <v-chip
                      v-if="glossaryPhrase.published"
                      color="green"
                      style="color: white"
                      class="ma-2"
                      small
                      >公開</v-chip
                    >
                    <v-chip v-else color="red" style="color: white" small class="ma-2"
                      >非公開</v-chip
                    >
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      x-small
                      color="primary"
                      :to="glossaryPhraseEditPath(glossaryPhrase)"
                    >
                      <v-icon left small> mdi-pencil </v-icon>編集
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      tile
                      outlined
                      x-small
                      color="danger"
                      @click="deleteGlossaryPhrase(glossaryPhrase, index)"
                    >
                      <v-icon left small> mdi-delete </v-icon>削除
                    </v-btn>
                  </td>

                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
          >
            <template v-slot:no-more>
              <v-chip label outlined> 全て表示されました。 </v-chip>
            </template>
            <template v-slot:no-results>
              <v-chip label outlined> 表示できるものがありません。 </v-chip>
            </template>
          </infinite-loading>
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'
import PermissionGuard from '@/components/commons/PermissionGuard'
import headUtilsMixin from '@/mixins/head_utils'
import { mapState } from 'vuex'
import { deserialize } from 'deserialize-json-api'
import urlUtils from '@/mixins/url_utils'

export default {
  components: {
    PermissionGuard, InfiniteLoading
  },
  mixins: [headUtilsMixin, urlUtils],
  data: () => {
    return {
      pageTitle: '用語集設定',
      glossaryPhrases: [],
      infiniteId: +new Date(),
      page: 1,
      glossaryPhrase: {},
      query: {
        name_cont: null,
        reading_ja_cont: null
      }

    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    })
  },
  methods: {
    search () {
      this.page = 1
      this.glossaryPhrases = []
      this.infiniteId++
    },
    infiniteHandler ($state) {
      axios
        .get('/api/glossary_phrases', {
          params: {
            page: this.page,
            q: this.query
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const desirializedData = deserialize(data).data
          if (desirializedData.length) {
            this.page++
            this.glossaryPhrases = this.glossaryPhrases.concat(desirializedData)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    deleteGlossaryPhrase (glossaryPhrase, index) {
      if (confirm('本当に削除しますか?')) {
        axios.delete(`/api/glossary_phrases/${glossaryPhrase.id}`).then(
          () => {
            this.glossaryPhrases.splice(index, 1)
            const payload = {
              status: 200,
              message: '削除しました。'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
      }
    },
    glossaryPhraseEditPath (glossaryPhrase) {
      return `/admin/glossary_phrases/${glossaryPhrase.id}/edit`
    },
    publicUrl () {
      return this.siteUrlOrigin() + this.mediaRootPath() + 'glossary'
    },
    previewUrl () {
      return '/preview/glossary'
    },
    siteUrlOrigin () {
      if (!this.site || !this.site.id) {
        return ''
      }

      return this.site.initialDomainWithProtocol
    },
    toggleDisplayGlossary (displayGlossary) {
      const query = {
        site: {
          displayGlossary: !displayGlossary
        }
      }
      axios.patch(`/api/sites/${this.site.id}`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.$store.dispatch('SiteStore/fetchSiteReference')
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
